<template>
  <div>
    <b-form @submit.prevent="submit">
      <b-row>
        <b-col cols="12" md="12" class="">
          <b-alert :show="mode === 'add'" variant="info">
            <i class="fas fa-info-circle fa-lg mr-1" />
            <b v-text="$lang.azmoonLang.just_one_image" />
          </b-alert>
        </b-col>
        <b-col cols="12" md="12">
          <b-form-group
            v-if="!(this.item && Object.keys(this.item).length)"
            label="نوع گزینه"
          >
            <b-form-radio-group
              id="radio-group-1"
              v-model="selected"
              :options="options"
              name="radio-options"
            >
            </b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <tagComponent
            :requiredLabel="false"
            :label="$lang.azmoonLang.option_group"
            category_name="option_group"
            :parentValue="option_group_selected"
            @getSelected="getGroupSelected"
            :parentPermissions="parentPermissions"
          />
        </b-col>
        <b-col cols="12" md="12">
          <UploadFile
            v-if="resourceId && showUpload && selected === 1"
            keyServies="option"
            :keyValue="resourceId"
            attachment_type_name="attachment_type_question_option"
            :parentAttachmentTypeId="28"
            :file_types="file_types"
            :showForm="false"
            @getFiles="updateAllFiles"
          />
        </b-col>
        <b-col
          v-if="!showUpload && selected === 1"
          cols="12"
          md="12"
          class="mt-2"
        >
          <label for="">{{ $lang.azmoonLang.send_file }}</label>
          <fileDrag
            ref="fileDrag"
            @uploadFile="attachmentTemp"
            :acceptFormats="acceptFormats"
            :acceptFormatsInput="acceptFormatsInput"
            :multiple="false"
            :crop="true"
          />
          <filelistPorgress
            :fileUpload="fileUpload"
            @removeFile="removeFileProgress"
            @getResponseCode="filesCode"
            :attachmentTypeId="28"
            :showButton="false"
          />
        </b-col>
        <b-col v-if="selected == 2" cols="12" md="12">
          <b-form-group
            :label="$lang.azmoonLang.title_option"
            label-for="description"
            :label-cols="$config.azmoon.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.azmoonLang.title_option"
              :rules="$v.option_description.$params"
            />
            <Editor
              v-model="$v.option_description.$model"
              :toolbarItems="editorToolbarItems"
            />
            <b-form-invalid-feedback id="option_description-feedback">
              {{
                $lang.azmoonLang.error_required
                  | replace($lang.azmoonLang.title_option)
              }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" v-if="mode == `edit`">
          <b-form-group
            :label="$lang.azmoonLang.type"
            label-for="is_enable"
            :label-cols="12"
          >
            <requiredComponent
              slot="label"
              :label="$lang.azmoonLang.status"
              :rules="$v.is_enable.$params"
            />
            <b-form-radio-group
              id="is_enable"
              :autocomplete="$lang.azmoonLang.status"
              v-model="$v.is_enable.$model"
              :state="$v.is_enable.$dirty ? !$v.is_enable.$error : null"
              :options="is_enable_options"
              buttons
              button-variant="outline-primary"
              size="md"
              name="radio-btn-outline"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="12">
          <div class="form-group form-btn text-right">
            <b-button
              v-if="responseCode.length || allFiles.length || selected === 2"
              type="submit"
              size="md"
              variant="success"
            >
              {{ $lang.azmoonLang.submitButton }}
              <i class="fa fa-check"></i>
            </b-button>
            <b-button
              class="ml-2"
              size="md"
              variant="danger"
              @click="handleBack"
            >
              {{ $lang.azmoonLang.cancelButton }}
              <i class="fa fa-ban"></i>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import Editor from "@/components/ckeditor/editorWithoutImg";
import UploadFile from "@/components/base/uploadFile";
import fileDrag from "@/components/fileManager/fileDrag";
import filelistPorgress from "@/components/fileManager/filelistPorgress";
import tagComponent from "@/components/tag/tagComponent";
import { pathOr } from "ramda";
import { createPureDom } from "@/shared/utils";

export default {
  name: "option-from",
  components: {
    UploadFile,
    fileDrag,
    Editor,
    filelistPorgress,
    tagComponent,
  },
  validations: {
    option_description: {},
    is_enable: {},
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    showUpload: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      selected: 1,
      options: [
        {
          text: "عکس",
          value: 1,
        },
        {
          text: "متن",
          value: 2,
        },
      ],
      is_enable_options: [],
      option_description: "",
      is_enable: 1,
      is_image: 1,
      option_group_selected: null,
      resourceId: null,
      file_types: ["image"],
      acceptFormatsInput: "image",
      fileUpload: [],
      responseCode: [],
      parentPermissions: ["admin", "edit"],
      acceptFormats: [
        {
          caption: "عکس",
          value: "10MB",
        },
      ],
      allFiles: [],
      editorToolbarItems: [
        "alignment",
        "subscript",
        "superscript",
        "|",
        "blockQuote",
        "bulletedList",
        "numberedList",
        "todoList",
        "|",
        "undo",
        "redo",
      ],
    };
  },
  created() {
    this.getValue();
    this.fetchData();
  },
  methods: {
    pathOr,
    createPureDom,
    getGroupSelected(item) {
      this.option_group_selected = item;
    },
    handleBack() {
      this.$emit("cancel");
    },
    updateAllFiles(files) {
      this.allFiles = files;
    },
    removeFileProgress(item) {
      let indexFile = this.fileUpload.indexOf(item);
      let response = this.responseCode.find((x) => x.name == item.name);
      let indexResponse = this.responseCode.indexOf(response);
      this.fileUpload.splice(indexFile, 1);
      this.responseCode.splice(indexResponse, 1);
      this.$refs.fileDrag.$refs.fileupload.value = "";
    },
    filesCode(code) {
      this.responseCode = code;
      this.$emit("responseCode", this.responseCode);
    },
    attachmentTemp(files) {
      this.btnHidden = true;
      this.fileUpload = [...this.fileUpload, ...files];
      // this.$emit("attachmentTemp", files)
    },
    getValue() {
      let values;

      values = [
        {
          value: 1,
          text: "فعال",
        },
        {
          value: 0,
          text: "غیرفعال",
        },
      ];

      this.is_enable_options = values;
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }

      if (this.selected === 2) {
        this.is_image = 0;
      }
      let payload = {
        is_enable: this.is_enable,
        option_description: this.option_description,
        is_image: this.is_image,
        option_group_id:
          this.option_group_selected && this.option_group_selected.value,
      };
      this.$emit("submit", payload);
    },
    fetchData() {
      if (this.item && Object.keys(this.item).length) {
        this.resourceId = pathOr(null, ["id"], this.item);
        this.is_enable = pathOr(null, ["idis_enable"], this.item);
        const isImage = pathOr(null, ["is_image"], this.item);
        this.selected = isImage === 1 ? 1 : 2;
        this.option_group_selected = {
          value: pathOr(null, ["option_group", "id"], this.item),
          text: pathOr(null, ["option_group", "caption"], this.item),
        };
        this.option_description = createPureDom(
          pathOr(null, ["option_description"], this.item)
        );
      }
    },
  },
};
</script>
